import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
    mode: 'light',
    primary: {
        main: '#2374FB',
        contrastText: 'black',
    },
    secondary: {
        main: '#0745ff',
    },
    background: {
        default: '#F1F6FA',
        paper: '#FFFFFF',
    },
    common: {
        black: '#111',
    },
};
